{
  const BaseModule = require('_base/base')

  const CLASS_TABLE_STICKY = 'is__sticky'

  class StickyTable extends BaseModule {
    get viewportHeight() {
      return window.innerHeight
    }

    get hasThead() {
      return !!this.$el.find('thead').length
    }

    get isFirefox() {
      const userAgent = navigator.userAgent.toLowerCase()

      return userAgent.includes('firefox')
    }

    get isSticky() {
      if (this.isFirefox) return false

      const tableHeight = this.$el.height()

      return this.hasThead && tableHeight > this.viewportHeight
    }

    postInit() {
      this.$tableHead = this.$el.find('thead th, thead td')
      this.$tablePage = this.$el.closest('.page')
    }

    postCalculate() {
      this.$el.toggleClass(CLASS_TABLE_STICKY, this.isSticky)
    }

    preRender() {
      if (this.isSticky) {
        this.attachTableHead()
      }
    }

    attachTableHead() {
      const theadTrHeight = this.$tableHead[0].offsetHeight
      const toTableEnd = this.$tablePage.length > 0 ? this.calcDistanceToPageEdge() : theadTrHeight 
      const margin = this.viewportHeight - theadTrHeight - toTableEnd

      this.$tableHead.css({ 'margin-bottom': margin })
    }

    calcDistanceToPageEdge() {
      const tableHeight = this.$el.height()
      const tablePageHeight = this.$tablePage[0].offsetHeight
      const tableOffsetRelativePage = this.$el.offset().top - this.$tablePage.offset().top
      
      return tablePageHeight - tableHeight - tableOffsetRelativePage
    }
  }

  $('table:not(.is__tableClone)').each(function() {
    new StickyTable($(this))
  })
}
